<div class="certificates-page">
  @if (certificates(); as page) {
    <section class="certificate-hero">
      <div class="certificate-hero-copy">
        <span class="kicker">DriveMe Academy</span>
        <h1>Meine Zertifikate</h1>
        <p>
          Teilnahmebestätigungen, öffentliche Prüfnachweise und PDF-Downloads an einem zentralen Ort.
        </p>

        <div class="certificate-hero-meta">
          <span>{{ summary().total }} Nachweise</span>
          <span>{{ summary().valid }} gültig</span>
          <span>{{ summary().issued }} ausgestellt</span>
          <span>{{ summary().expired }} abgelaufen</span>
        </div>
      </div>

      @if (superAdmin()) {
      }
    </section>

    <section class="certificate-stat-grid">
      <article class="certificate-stat-card">
        <span>Gesamt</span>
        <strong>{{ summary().total }}</strong>
        <small>Alle erfassten Zertifikate</small>
      </article>

      <article class="certificate-stat-card accent">
        <span>Gültig</span>
        <strong>{{ summary().valid }}</strong>
        <small>Aktuell nutzbare Nachweise</small>
      </article>

      <article class="certificate-stat-card">
        <span>Ausgestellt</span>
        <strong>{{ summary().issued }}</strong>
        <small>Frisch erzeugte Zertifikate</small>
      </article>

      <article class="certificate-stat-card danger">
        <span>Abgelaufen</span>
        <strong>{{ summary().expired }}</strong>
        <small>Erfordern eine Prüfung</small>
      </article>
    </section>

    <section class="panel section-stack certificate-list-panel">
      <div class="panel-heading certificate-list-heading">
        <div>
          <h2>Ausgestellte Nachweise</h2>
          <p>Öffne einen Nachweis, prüfe die Details oder lade das PDF direkt aus dem Portal herunter.</p>
        </div>
        <div class="badge">{{ page.total }} Einträge</div>
      </div>

      <div class="certificate-table-shell">
        <table class="table certificate-table">
          <thead>
            <tr>
              <th>Nummer</th>
              <th>Teilnehmer</th>
              <th>Kurs</th>
              <th>Ausgestellt</th>
              <th>Gültig bis</th>
              <th>Status</th>
              <th>Aktion</th>
            </tr>
          </thead>
          <tbody>
            @for (certificate of page.items; track certificate.id) {
              <tr>
                <td>
                  <a class="table-link" [routerLink]="['/certificates', certificate.id]">{{ certificate.certificateNumber }}</a><br>
                  <span>{{ formatDate(certificate.issuedAt) }}</span>
                </td>
                <td>{{ certificate.driverName }}</td>
                <td>{{ certificate.courseTitle }}</td>
                <td>{{ formatDate(certificate.issuedAt) }}</td>
                <td>{{ certificate.validUntil ? formatDate(certificate.validUntil) : '-' }}</td>
                <td><span class="badge">{{ statusLabel(certificate.status) }}</span></td>
                <td>
                  <a class="table-link" [routerLink]="['/certificates', certificate.id]">Öffnen</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  } @else {
    <div class="empty">Zertifikate werden geladen.</div>
  }
</div>
